import React from 'react';
import '../styles/ProjectCard.css';

const ProjectCard = ({ title, description, outcome, image, link, tags, index }) => {
  const hasLiveLink = Boolean(link && !link.includes('github.com/momenmedhatsalem'));

  return (
    <div
      className="project-card"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <div className="project-image">
        {hasLiveLink && (
          <div className="image-overlay">
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="project-link"
            >
              Visit Live Project ↗
            </a>
          </div>
        )}

        {typeof image === 'string' && image.startsWith('linear-gradient') ? (
          <div className="project-placeholder" style={{ background: image }}>
            <div className="placeholder-icon">
              <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <span className="project-placeholder-label">Architecture & Production System</span>
          </div>
        ) : (
          <img src={image} alt={title} className="project-image-img" loading="lazy" />
        )}
      </div>

      <div className="project-info">
        <h3 className="project-title">{title}</h3>
        <p className="project-description">{description}</p>

        {outcome && (
          <div className="project-outcome">
            <span className="project-outcome-icon">⚡</span>
            <span className="project-outcome-text">
              <strong>Key Impact:</strong> {outcome}
            </span>
          </div>
        )}

        {tags && tags.length > 0 && (
          <div className={`project-tags ${!hasLiveLink ? 'no-footer' : ''}`}>
            {tags.map((tag, idx) => (
              <span key={idx} className="tag">{tag}</span>
            ))}
          </div>
        )}

        {hasLiveLink && (
          <div className="project-card-footer">
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="project-mobile-btn"
            >
              <span>Visit Live Project</span>
              <span className="project-btn-arrow">↗</span>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
